import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-ai-admin-shell',
    templateUrl: './ai-admin-shell.component.html',
    styleUrls: ['./ai-admin-shell.component.scss']
})
export class AiAdminShellComponent implements OnInit {
    currentTab: 'dashboard' | 'settings' = 'dashboard';

    tabs = [
        { id: 'dashboard', label: 'Dashboard', icon: '📊' },
        { id: 'settings', label: 'Configuración', icon: '⚙️' }
    ];

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        // Detectar qué tab es el activo basándose en la URL
        this.detectActiveTab();
    }

    private detectActiveTab(): void {
        const url = this.router.url;
        if (url.includes('settings')) {
            this.currentTab = 'settings';
        } else {
            this.currentTab = 'dashboard';
        }
    }

    selectTab(tabId: 'dashboard' | 'settings'): void {
        this.currentTab = tabId;
        this.router.navigate([tabId], { relativeTo: this.route });
    }
}
